import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  numSelected: number;
  filterName: string;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch?: () => void;
  onExportClick?: () => void;
};

export default function PermissionTableToolbar({ 
  numSelected, 
  filterName, 
  onFilterName,
  onClearSearch,
  onExportClick,
}: Props) {
  return (
    <Toolbar
      sx={{
        height: 96,
        display: 'flex',
        justifyContent: 'space-between',
        p: (theme) => theme.spacing(0, 1, 0, 3),
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} öğe seçildi
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <OutlinedInput
            value={filterName}
            onChange={onFilterName}
            placeholder="İzin ara... (Gerçek zamanlı filtreleme)"
            startAdornment={
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ color: 'text.disabled', width: 20, height: 20 }}
                />
              </InputAdornment>
            }
          />
          
          {filterName && onClearSearch && (
            <IconButton
              onClick={onClearSearch}
              sx={{ 
                bgcolor: 'error.main', 
                color: 'white',
                '&:hover': { bgcolor: 'error.dark' }
              }}
            >
              <Iconify icon="eva:close-fill" />
            </IconButton>
          )}
        </Box>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Sil">
          <Button
            color="error"
            variant="contained"
            startIcon={<Iconify icon="eva:trash-2-outline" />}
          >
            Sil
          </Button>
        </Tooltip>
      ) : (
        <Stack direction="row" spacing={1}>
          <Tooltip title="Dışa Aktar">
            <Button
              color="inherit"
              startIcon={<Iconify icon="eva:download-outline" />}
              onClick={onExportClick}
            >
              Dışa Aktar
            </Button>
          </Tooltip>
          <Tooltip title="Filtrele">
            <Button
              color="inherit"
              startIcon={<Iconify icon="ic:round-filter-list" />}
            >
              Filtrele
            </Button>
          </Tooltip>
        </Stack>
      )}
    </Toolbar>
  );
} 